import "@/App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";

import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ProtectedRoute from "./components/ProtectedRoute";
import PortalLayout from "./components/PortalLayout";

// Public pages
import Home from "./pages/Home";
import About from "./pages/About";
import BusinessAreas from "./pages/BusinessAreas";
import BusinessAreaDetail from "./pages/BusinessAreaDetail";
import GlobalPresence from "./pages/GlobalPresence";
import Values from "./pages/Values";
import Contact from "./pages/Contact";
import Advisory from "./pages/Advisory";

// Portal pages
import Login from "./pages/portal/Login";
import Register from "./pages/portal/Register";
import Dashboard from "./pages/portal/Dashboard";
import RfqList from "./pages/portal/RfqList";
import NewRfq from "./pages/portal/NewRfq";
import RfqDetail from "./pages/portal/RfqDetail";
import AdminUsers from "./pages/portal/AdminUsers";

const PublicShell = ({ children }) => (
    <div className="min-h-screen flex flex-col bg-white">
        <Header />
        <main className="flex-1">{children}</main>
        <Footer />
    </div>
);

function App() {
    return (
        <div className="App bg-white">
            <HashRouter>
                <AuthProvider>
                    <ScrollToTop />
                    <Routes>
                        {/* Portal — full-screen, no public header/footer */}
                        <Route path="/portal/login" element={<Login />} />
                        <Route path="/portal/register" element={<Register />} />
                        <Route
                            path="/portal"
                            element={
                                <ProtectedRoute>
                                    <PortalLayout />
                                </ProtectedRoute>
                            }
                        >
                            <Route index element={<Dashboard />} />
                            <Route path="rfqs" element={<RfqList />} />
                            <Route path="rfqs/new" element={<NewRfq />} />
                            <Route path="rfqs/:id" element={<RfqDetail />} />
                            <Route
                                path="users"
                                element={
                                    <ProtectedRoute adminOnly>
                                        <AdminUsers />
                                    </ProtectedRoute>
                                }
                            />
                        </Route>

                        {/* Public site */}
                        <Route path="/" element={<PublicShell><Home /></PublicShell>} />
                        <Route path="/about" element={<PublicShell><About /></PublicShell>} />
                        <Route path="/business-areas" element={<PublicShell><BusinessAreas /></PublicShell>} />
                        <Route path="/business-areas/:slug" element={<PublicShell><BusinessAreaDetail /></PublicShell>} />
                        <Route path="/global-presence" element={<PublicShell><GlobalPresence /></PublicShell>} />
                        <Route path="/values" element={<PublicShell><Values /></PublicShell>} />
                        <Route path="/contact" element={<PublicShell><Contact /></PublicShell>} />
                        <Route path="/advisory" element={<PublicShell><Advisory /></PublicShell>} />
                        <Route path="*" element={<PublicShell><Home /></PublicShell>} />
                    </Routes>
                </AuthProvider>
            </HashRouter>
        </div>
    );
}

export default App;
